/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { DeleteClearanceCaseDocumentResponseJson } from './delete-clearance-case-document-response-json';
import { DeleteClearanceCaseDocumentResult } from '../results/delete-clearance-case-document-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { ClearanceCaseDto } from '../models/clearance-case-dto';
import { CaseDto } from '../models/case-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class DeleteClearanceCaseDocumentResponse extends ResponseWithErrorGeneric<DeleteClearanceCaseDocumentResponseJson, DeleteClearanceCaseDocumentResult> implements IResponseWithErrorGeneric<DeleteClearanceCaseDocumentResult> {
  public clearanceCaseId: string = undefined;
  public clearanceCase: ClearanceCaseDto;
  public case: CaseDto;

  //<custom-body>
  constructor(response: HttpResponse<DeleteClearanceCaseDocumentResponse>) {
    super(response, DeleteClearanceCaseDocumentResult.Error);
    if (this.result === DeleteClearanceCaseDocumentResult.Success) {
      this.case = this.body.case ? new CaseDto(this.body.case) : null;
      this.clearanceCase = new ClearanceCaseDto(this.body.clearanceCase, this.case);
    }
  }
  //</custom-body>
}
